import React, { useEffect } from "react";
import { Chart as ChartJS, ArcElement, Title } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Title);

const DoughnutChart = (props) => {
  const percentage = props.percentage;
  const difference = 100 - percentage;
  let percentageColour;

  if (percentage <= 40) {
    percentageColour = "#FF323C";
  } else if (percentage > 40 && percentage <= 60) {
    percentageColour = "#FF9432";
  } else {
    percentageColour = "#35BF6D";
  }

  useEffect(() => {}, [props]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: props.title + " - " + props.percentage + "%",
        align: "end",
        font: {
          family: "Poppins",
          weight: "500",
        },
      },
    },
  };

  const data = {
    labels: ["Red"],
    datasets: [
      {
        data: [percentage, difference],
        backgroundColor: [percentageColour, "#DDDDDD"],
      },
    ],
  };
  return <Doughnut data={data} options={options} />;
};

export default DoughnutChart;
